import { Route, Switch, useLocation } from "react-router-dom";
import GlobalStyle from "./globalStyles";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import styled, { keyframes, ThemeProvider } from "styled-components";
import { lightTheme, darkTheme } from "./components/Themes";


import Home from "./components/Home";
import AboutPage from "./components/AboutPage";
import WorkPage from "./components/WorkPage";
import Contact from "./components/Contact";
import SoundBar from "./subComponents/SoundBar";
import { Toggle } from "./components/Svgs";
import Logo from "./assets/Images/logo.gif";

const ImgLogo = styled.div`
  .logo {
    position: fixed;
    left: 0rem;
    top: 0rem;
    z-index: 1;
    width: 10vw;
    border-radius: 0 0% 70% 0%;

    @media (max-width: 742px) {
      width: 20vw;
    }
  }
`;

const FooterNote = styled.div`
  position: fixed;
  left: 1rem;
  bottom: 1rem;
  font-size: 0.8rem;
  color: ${(props) => props.theme.text};
  opacity: 0.7;
  z-index: 1;

  @media (max-width: 600px) {
    font-size: 0.7rem;
    left: 0.75rem;
    bottom: 0.75rem;
  }
`;

const rotate = keyframes`
from{
  transform: rotate(0);
}

to{
  transform: rotate(360deg);
}
`;

const ThemeMode = styled.button`
  position: absolute;
  top: 0%;
  left: 50%;
  border: none;
  outline: none;
  transform: translate(-50%, -50%);
  background-color: transparent;
  transition: all 1s ease;
  cursor: pointer;
  z-index: 1;

  .toggle {
    animation: ${rotate} infinite 5s linear;
    width: 15rem;
    position: relative;
  }
  @media (max-width: 466px) {
    .toggle {
      width: 12rem;
    }
  }
`;

function App() {
  const location = useLocation();

  const [theme, setTheme] = useState("dark");
  const toggleTheme = () => {
    if (theme === "dark") {
      setTheme("light");
    } else {
      setTheme("dark");
    }
  };

  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={theme === "dark" ? darkTheme : lightTheme}>
        <ThemeMode click={click} onClick={toggleTheme}>
          <Toggle
            className="toggle"
            onClick={() => handleClick()}
            fill={click ? "#E2DDDB" : "#171717"}
          />
        </ThemeMode>
        <ImgLogo>
          <img src={Logo} alt="logo" className="logo" />
        </ImgLogo>
        <SoundBar />

        <FooterNote>
          © 2022 · My Old Portfolio. New one is way cooler.
        </FooterNote>

        <AnimatePresence exitBeforeEnter>
          <Switch location={location} key={location.pathname}>
            <Route exact path="/" component={Home} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/about" component={AboutPage} />
            <Route exact path="/work" component={WorkPage} />
          </Switch>
        </AnimatePresence>
      </ThemeProvider>
    </>
  );
}

export default App;
